import { queryOptions } from "@tanstack/react-query";
import { apiGet } from "@softmax/observatory-client/client";
import type { MyUsageResponse } from "@softmax/observatory-client/types";
import type { AccountUsagePeriod } from "@softmax/product-ux/account";

export function accountUsageQueryOptions({
  viewerId,
  period,
}: {
  viewerId: string;
  period: AccountUsagePeriod;
}) {
  return queryOptions({
    queryKey: [
      "usage",
      "me",
      { viewerId, elevatedPrivileges: false, period },
    ] as const,
    queryFn: ({ signal }) =>
      apiGet<MyUsageResponse>(`/usage/me?period=${period}`, {
        signal,
        elevatedPrivileges: false,
      }),
    staleTime: 30_000,
  });
}
